import { Injectable } from '@angular/core'
import { SubmissionQueries, SubmissionsQuery, Post } from '../submissions/submission.queries'
import { Apollo } from 'apollo-angular'
import gql from 'graphql-tag'

@Injectable({providedIn: 'root'})
export class PostBoxMutations {
  constructor(
    private queries: SubmissionQueries,
    private apollo: Apollo
  ) {}

  wlReviewPost({
    post,
    content,
    stars,
    action
  }: {
    post: Post,
    content: string,
    stars: number,
    action: 'approve' | 'reject'
  }): Promise<any> {
    return this.apollo.mutate({
      mutation: gql`
        mutation wlReviewPost($input: WlReviewPostInput!) {
          WlReviewPost(input: $input) {
            errors
            post {
              id
            }
          }
        }
      `,
      variables: {
        input: {
          customerId: post.customerId,
          postId: post.id,
          content,
          stars,
          action
        }
      },
      refetchQueries: [
        { query: SubmissionsQuery, variables: this.queries.lastQueryVariables['SubmissionsQuery'] }
      ],
    }).toPromise()
  }
}
